<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="stats"
      y-value-prefix="stats."
      x-value="date"
      :chart-value-keys="chartValueKeys"
      :yaxis="yAxisConfig"
      :fill="fillConfig"
      :colors="['#8F6BE5', '#EB4646', '#00BFFF']"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.team_sleep_quality') }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.team_sleep_quality') }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="stats"
      >
        <template v-slot:item.date="{ item }">
          {{ formatDate(item.date) }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import dayjs from 'dayjs'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'TeamSleepStatusTrendChart',
  components: { ChartListViewTable, LineChart, VisualListToggle },
  props: {
    stats: {
      type: Array,
      required: true,
      default: () => []
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      return [
        {
          key: 'SLQ',
          label: this.$t('variables.SLQ.long'),
          type: 'bar'
        },
        {
          key: 'FAT',
          label: this.$t('variables.FAT.long'),
          type: 'bar'
        },
        {
          key: 'SLD',
          label: this.$t('variables.SLD.long'),
          type: 'bar'
        }
      ]
    },
    yAxisConfig() {
      return [
        {
          min: 0,
          max: 5,
          title: { text: this.$t('variables.SLQ.long') },
          seriesName: 'SLQ'
        },
        {
          min: 0,
          max: 5,
          title: { text: this.$t('variables.FAT.long') },
          seriesName: 'FAT'
        },
        {
          min: 0,
          max: Math.max(12, ...this.stats.map(s => s.stats?.SLD || 0)),
          title: { text: this.$t('variables.SLD.long') },
          seriesName: 'SLD',
          opposite: true
        }
      ]
    },
    fillConfig() {
      return {
        type: ['solid', 'solid', 'solid'],
        opacity: [0.7, 0.7, 0.7],
        gradient: {
          inverseColors: false,
          shade: 'light',
          type: 'vertical',
          opacityFrom: 0.55,
          opacityTo: 0.25
        }
      }
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.date'),
          value: 'date',
          sortable: true,
          width: '20%'
        },
        {
          text: this.$t('variables.SLQ.long'),
          value: 'stats.SLQ',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.FAT.long'),
          value: 'stats.FAT',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.SLD.long'),
          value: 'stats.SLD',
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('ll')
    }
  }
}
</script>
